export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_ERROR = "GET_USERS_ERROR"

export const ADD_USER = "ADD_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_ERROR = "ADD_USER_ERROR"

export const EDIT_USER = "EDIT_USER"
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS"
export const EDIT_USER_ERROR = "EDIT_USER_ERROR"

export const EDIT_PASSWORD_USER = "EDIT_PASSWORD_USER"
export const EDIT_PASSWORD_USER_SUCCESS = "EDIT_PASSWORD_USER_SUCCESS"
export const EDIT_PASSWORD_USER_ERROR = "EDIT_PASSWORD_USER_ERROR"

export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_ERROR = "DELETE_USER_ERROR"

export const RESET_PASSWORD_USER = "RESET_PASSWORD_USER"
export const RESET_PASSWORD_USER_SUCCESS = "RESET_PASSWORD_USER_SUCCESS"
export const RESET_PASSWORD_USER_ERROR = "RESET_PASSWORD_USER_ERROR"

export const SET_USER_PAGE = "SET_USER_PAGE"
export const SET_USER_TOTAL_PAGE = "SET_USER_TOTAL_PAGE"

export const RESET_USER_FLAG = "RESET_USER_FLAG"
